<template>
  <div class="soushin-kanryou">
    <div class="soushin-kanryou_step">
      <FormStep v-bind:step="3"></FormStep>
    </div>
    <div class="soushin-kanryou_p">
      <h1 class="soushin-kanryou_p-h1">お申し込みありがとうございました</h1>
      <p>ご入力頂きましたメールアドレスに控えのメールを自動返信致しましたのでご確認下さい。</p>
      <p>
        控えメールが届かない場合、ご入力頂いたメールアドレスに誤りがあるか、
        インターネット上のなんらかのトラブルの可能性もございますので、
        お手数ですが弊社までお電話頂くか、再度お問い合わせ頂くようお願い申し上げます。
      </p>
      <p>ご質問、ご要望についての回答に関しましては、近日中にお電話もしくはメールにてご回答致します。</p>
    </div>
    <FormBtn>
      <div v-on:click="returnMenu">
        <slot>トップメニューに戻る</slot>
      </div>
    </FormBtn>
  </div>
</template>
<script>
import FormStep from "@/components/form_step.vue";
import FormBtn from "@/components/form_btn.vue";
export default {
  metaInfo: {
    title: "送信完了"
  },
  components: { FormStep, FormBtn },
  methods:{
    returnMenu(){
      this.$router.push("/");
    }
  },
  mounted(){
    var self = this;
    window.addEventListener("popstate",function(){
     self.$router.push("/")
    })  
  }
};
</script>

<style lang="scss">
.soushin-kanryou {
  @media screen and (min-width: 769px) {
    max-width: 800px;
    text-align: center;
    margin: 0 auto;
    &_p {
      margin: 60px 0;
    }
  }
  @media screen and (max-width: 768px) {
      &_p {
      text-align: center;
      &-h1 {
        font-size: 150%;
        margin: 10% 0;
      }
      p{
        margin: 5% 7%;
      }
    } 
    }
}
</style>
